import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  padding: (p) => p.spacing(1, 0.5),
};

export const accDetail: SxStyleFunc<boolean | undefined> = () => ({
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(0, 0, 1, 1),
});

export const icon: SxStyleFunc<boolean | undefined> = (open) => ({
  color: open ? (p) => p.palette.primary[600] : (p) => p.palette.primary[400],
});

export const title: SxStyleFunc<boolean | undefined> = () => ({
  color: (p) => p.palette.primary[400],
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
});

export const summary: SxStyleFunc<boolean | undefined> = (open) => ({
  background: open
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.common.white,
  borderRadius: open ? (p) => p.spacing(1, 1, 0, 0) : (p) => p.spacing(1),
  borderColor: (p) => p.palette.primary[100],
});

export const badge: SxStyleFunc<boolean | undefined> = (expanded) => ({
  fontSize: (p) => p.typography.caption,
  background: expanded
    ? (p) => p.palette.common.white
    : (p) => p.palette.primary[100],
  color: (p) => p.palette.primary[500],
  width: (p) => p.spacing(2.5),
  height: (p) => p.spacing(2.5),
  textAlign: 'center',
  borderRadius: '50%',
  fontWeight: 500,
});
